angular.module('dialogs')
    .controller('InformationDialogCtrl',
    [
        '$scope', '$modalInstance', 'eventId', '$location', 'gameId', '$routeParams',
        function ($scope, $modalInstance, eventId, $location, gameId, $routeParams) {

            $scope.DisplayContinueToPublishResultButton = $.IsStepByStepOn();

            $scope.ContinueToPublishResult = function () {
                $modalInstance.dismiss('no');
                $location.path("publishresults/" + eventId)
                    .search({
                        sportCode: $routeParams.sportCode,
                        startDate: $routeParams.startDate,
                        gameId: gameId,
                        no: $routeParams.no
                    });
            };

            $scope.no = function () {
                $modalInstance.dismiss('no');
            };
        }
    ]);